var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanoNacionalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 35V31.6667H15.4167V29.1667H18.75V24.9167C16.4722 24.6111 14.5833 23.5903 13.0833 21.8542C11.5833 20.1181 10.8333 18.0972 10.8333 15.7917C10.8333 13.2639 11.7292 11.1111 13.5208 9.33333C15.3125 7.55555 17.4722 6.66666 20 6.66666C22.5278 6.66666 24.6875 7.55555 26.4792 9.33333C28.2708 11.1111 29.1667 13.2639 29.1667 15.7917C29.1667 18.0972 28.4167 20.1181 26.9167 21.8542C25.4167 23.5903 23.5278 24.6111 21.25 24.9167V29.1667H24.5833V31.6667H21.25V35H18.75ZM20 22.5C21.8333 22.5 23.4028 21.8472 24.7083 20.5417C26.0139 19.2361 26.6667 17.6667 26.6667 15.8333C26.6667 14 26.0139 12.4306 24.7083 11.125C23.4028 9.81944 21.8333 9.16666 20 9.16666C18.1667 9.16666 16.5972 9.81944 15.2917 11.125C13.9861 12.4306 13.3333 14 13.3333 15.8333C13.3333 17.6667 13.9861 19.2361 15.2917 20.5417C16.5972 21.8472 18.1667 22.5 20 22.5Z",
    fill: "#337066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanoNacionalIcon);
export default __webpack_public_path__ + "static/media/plano_nacional_icon.c834ba16c4298defdb91ce6646f8cb01.svg";
export { ForwardRef as ReactComponent };